export const STT_PROVIDER_OPTIONS = [
  { value: 'deepgram', label: 'Deepgram' },
  { value: 'sarvam', label: 'Sarvam' }
];

// Deepgram always runs Nova 3 in Hindi on calls, so these are shown but can't be changed.
export const DEEPGRAM_FIXED = { model: 'Nova 3 (nova-3)', language: 'Hindi (hi)' };

export const SARVAM_MODEL_OPTIONS = [
  { value: 'saaras:v4', label: 'Saaras v4 (saaras:v4)' },
  { value: 'saaras:v3', label: 'Saaras v3 (saaras:v3)' }
];

export const SARVAM_LANGUAGE_OPTIONS = [
  { value: 'hi-IN', label: 'Hindi (hi-IN)' },
  { value: 'en-IN', label: 'English (en-IN)' },
  { value: 'unknown', label: 'Detect automatically' },
  { value: 'bn-IN', label: 'Bengali (bn-IN)' },
  { value: 'gu-IN', label: 'Gujarati (gu-IN)' },
  { value: 'kn-IN', label: 'Kannada (kn-IN)' },
  { value: 'ml-IN', label: 'Malayalam (ml-IN)' },
  { value: 'mr-IN', label: 'Marathi (mr-IN)' },
  { value: 'od-IN', label: 'Odia (od-IN)' },
  { value: 'pa-IN', label: 'Punjabi (pa-IN)' },
  { value: 'ta-IN', label: 'Tamil (ta-IN)' },
  { value: 'te-IN', label: 'Telugu (te-IN)' },
  { value: 'ur-IN', label: 'Urdu (ur-IN)' }
];

export const SARVAM_DEFAULTS = { model: 'saaras:v4', language: 'hi-IN' };
